<style type="text/less" lang="less">
.tooltip {
    .tooltip-arrow {
        margin: 0;
        border-color: transparent;
    }
}
</style>
<script type="text/babel">
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'
import collect from 'collect.js'

export default {
    mixins: [HasLoadingState, HasSubscriptions, RestoreOnPageBack],

    props: ['dataCampaign'],

    data() {
        return {
            campaign: this.dataCampaign,
            jobs: null,
            stopForm: new SparkForm({}),
        }
    },

    computed: {
        jobsApplied() {
            return collect(this.jobs)
                .filter(job => job.status === 'applied')
                .toArray()
        },

        jobsHired() {
            return collect(this.jobs)
                .reject(job => job.status === 'applied')
                .reject(job => job.status === 'declined')
                .toArray()
        },

        jobsDeclined() {
            return collect(this.jobs)
                .filter(job => job.status === 'declined')
                .toArray()
        },
    },

    mounted() {
        $(this.$el)
            .find('[data-toggle="tooltip"]')
            .tooltip()
    },

    created() {
        this.subscribe(Echo.private(`campaigns.${this.campaign.id}`))
            .listen('Services\\Campaigns\\Events\\CampaignUpdated', () => {
                this.loadCampaign()
                this.load(true)
            })
            .listen('Services\\Jobs\\Events\\JobApplied', () => this.load(true))

        this.onPageVisit(() => this.load())
        this.onPageRestore(() => this.load(true))
    },

    methods: {
        load(silently) {
            axios
                .get(route('api.campaign.jobs', this.campaign.id))
                .then(response => (this.jobs = response.data.data))
                .then(this.finishLoading(silently))
                .then(this.saveState)
        },

        loadCampaign() {
            axios
                .get(route('api.campaign.show', this.campaign.id))
                .then(response => Object.assign(this.campaign, response.data.data))
                .then(this.saveState)
        },

        stop(confirmed) {
            if (typeof confirmed === 'undefined') {
                swal(
                    {
                        title: 'Vil du stoppe kampagnen?',
                        text: 'Du kan publicere den igen senere hvis du skulle ønske det.',
                        customClass: 'danger',
                        showCancelButton: true,
                        confirmButtonText: 'Stop kampagne',
                        cancelButtonText: 'Annuller',
                        closeOnConfirm: true,
                        allowEscapeKey: true,
                        allowClickOutside: true,
                        type: 'warning',
                    },
                    this.stop
                )
            }
            if (confirmed) {
                Spark.delete(route('api.campaign.destroy', this.campaign.id), this.stopForm).then(
                    response => {
                        this.campaign = response.data
                    }
                )
            }
        },
    },
}
</script>
